import {Button, Modal, Spinner} from "react-bootstrap";
import React from 'react';
import {useState} from "react";

export default function DeleteWaterSystemModal({
                                                   setShow,
                                                   deleteWaterSystem,
                                                   selectedWaterSystemId,
                                                   show,
                                                   controlUnitId,
                                                   setShowDeleteWaterSystemConfirmationModal
                                               }) {
    const [isDeletingInProgress, setIsDeletingInProgress] = useState(false);

    const handleOk = async () => {
        setIsDeletingInProgress(true);
        await deleteWaterSystem(controlUnitId, selectedWaterSystemId);
        setIsDeletingInProgress(false);
        setShow(false);
        setShowDeleteWaterSystemConfirmationModal(true);
    }

    const handleCancel = () => {
        setShow(false);
    }

    return (
        <Modal dialogClassName="filter-modal" show={show} onHide={() => {
            if (!isDeletingInProgress) {
                setShow(false);
            }
        }} style={{marginTop: '10%', left: '1%'}}>
            <Modal.Header closeButton>
                <Modal.Title>Delete Water System</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Are you sure you want to remove this water system from the CU?
            </Modal.Body>
            <Modal.Footer>
                {
                    isDeletingInProgress ?
                        <Button disabled variant="primary">
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className='mr-1'
                            />
                            Deleting...
                        </Button>
                        :
                        <Button style={{width: 80}} onClick={() => handleOk()} variant="primary">OK</Button>
                }
                <Button disabled={isDeletingInProgress} style={{width: 80}} onClick={() => handleCancel()}
                        variant="primary">Cancel</Button>
            </Modal.Footer>
        </Modal>
    )
}
